import React from 'react';
import { useParams } from 'react-router-dom';
import ParkingDisplayForm from './ParkingDisplayForm';

export default function EditParkingDisplay() {
  let { id } = useParams();
  return <ParkingDisplayForm id={id} />;
}
